import { jsx } from "react/jsx-runtime";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { validateTidalLicense } from "../../base/index.js";
function RemoveCircleOutline(props) {
  return /* @__PURE__ */ jsx(
    RemoveCircleOutlineIcon,
    {
      "data-testid": "RemoveCircleOutline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "RemoveCircleOutline",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
RemoveCircleOutline.tidalIconMeta = {
  categories: "cancel,informative",
  name: "RemoveCircleOutline"
};
validateTidalLicense();
export {
  RemoveCircleOutline
};
//# sourceMappingURL=RemoveCircleOutline.js.map
